module.exports = "mutation ($id: ID!) {\n  ProductDelete(id: $id) {\n    id\n  }\n}\n"